// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_fw-6";
export var emphasizeQuantity = "_fw-3";
export var flatBottomCorners = "_fw-5";
export var productImage = "_fw-0";
export var quantityContainer = "_fw-2";
export var tooltip = "_fw-1";
export var wrapAndEllipsesOverflow = "_fw-4";